<template>
    <router-link
        v-if="!isDropdownToggle"
        class="navbar-nav-link"
        :class="[checkActive() ? 'active' : '']"
        :to="getRouteObject()"
    >
        <slot />
    </router-link>
    <a
        v-else
        class="navbar-nav-link"
        :class="[checkActive() ? 'active' : '']"
        href="#"
        :aria-expanded="navItem ? String(navItem.isOpen) : undefined"
        @click="handleClick"
    >
        <slot />
    </a>
</template>
<script>
export default {
    name: 'AppNavItemLink',
    inject: {
        navItem: { default: null }
    },
    props: {
        href: {
            type: String
        },
        isDropdownToggle: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        checkActive() {
            return this.href && (window.location.origin + this.$route.path).includes(this.href)
        },
        handleClick(event) {
            if (this.isDropdownToggle && this.navItem) {
                event.preventDefault()
                this.navItem.toggle()
            }
        },
        getRouteObject() {
            const url = new URL(this.href);
            return {
                path: url.pathname,
                query: Object.fromEntries(url.searchParams)
            }
        }
    }
}
</script>
